import _orderBy from 'lodash/orderBy'
import _map from 'lodash/map'
var firebase = window.firebase

function openConnection () {
  // Initialize Firebase
  var config = {
    apiKey: 'AIzaSyAAJxx7T982ObQAuijyyZGOhDmTRYIfi7c',
    authDomain: 'proof-f6589.firebaseapp.com',
    databaseURL: 'https://proof-f6589.firebaseio.com',
    projectId: 'proof-f6589',
    storageBucket: 'proof-f6589.appspot.com',
    messagingSenderId: '24029482974'
  }
  firebase.initializeApp(config)
}

/**
 * Return data from the specified firebase path
 * @param {array|string} path
 * @param {string} orderBy what property do you want to order by
 * @returns {promise}
 */
function get (path, orderBy) {
  var ref = path.join('/')
  return firebase
    .database()
    .ref(ref)
    .once('value')
    .then(function (snapshot) {
      var formatted = _map(snapshot.val(), function (v, k) {
        v['id'] = k
        return v
      })
      if (orderBy) {
        return _orderBy(formatted, orderBy)
      } else {
        return formatted
      }
    })
}

/**
 * Retrieve a single item from the firebase path
 * @param {array|string} path
 * @returns {promise}
 */
function getSingle (path) {
  var ref = path.join('/')
  return firebase
    .database()
    .ref(ref)
    .once('value')
    .then(function (snapshot) {
      var data = snapshot.val()
      if (data) {
        data.id = path[path.length - 1]
        return data
      }
    })
}

function getWhile (path, field, value) {
  var ref = path.join('/')
  return firebase
    .database()
    .ref(ref)
    .orderByChild(field)
    .equalTo(value)
    .once('value')
    .then(function (snapshot) {
      var formatted = _map(snapshot.val(), function (v, k) {
        v['id'] = k
        return v
      })
      return formatted
    })
}

function update (path, data) {
  var ref = path.join('/')
  return firebase
    .database()
    .ref(ref)
    .update(data)
}

function set (path, data) {
  var ref = path.join('/')
  return firebase
    .database()
    .ref(ref)
    .set(data)
}

function bindOrder (path, order, limit, cb) {
  const ref = path.join('/')
  firebase
    .database()
    .ref(ref)
    .orderByChild(order)
    .limitToLast(limit)
    .on('value', cb)
}

export default {
  openConnection,
  get,
  getSingle,
  getWhile,
  update,
  set,
  bindOrder
}



// WEBPACK FOOTER //
// ./src/database/index.js